import request from '@/http/request';

import store from '@/store';

/**
 * 调用 Agent 服务的通用方法
 * @param {Object} params - 请求参数
 * @param {Object} axiosConfig - 额外的 axios 配置（如 signal）
 * @returns {Promise}
 */
export function callAgent(params, axiosConfig = {}) {
  
  console.log('callAgent接收到axiosConfig:', axiosConfig);
  
  const requestConfig = {
    url: '/relay/rapi/agent',
    method: 'POST',
    data: {
      SystemId: '2',
      ...params,
      VueOperateUser: sessionStorage.getItem('userid'),
    },
    ...axiosConfig, // 合并额外的axios配置（如signal）
  };
  
  console.log('最终的request配置:', requestConfig);
  
  return request(requestConfig);
}

/**
 * 根据用户id灰度获取 OCR FlowKey
 * 规则：命中灰度名单 ocrGrayList 或名单为空数组时使用 ocrFlowNewKey，否则使用旧Key；
 * 当 ocrFlowNewKey 未配置时回退到旧Key；灰度解析异常时回退到旧Key。
 * @param {string} defaultKey - 调用方传入的默认FlowKey（旧Key），优先取 ocrFlowKey 配置
 * @returns {string} 最终使用的 OCR FlowKey
 */
function getOcrFlowKey(defaultKey = 'ocr_photo_new') {
  let ocrFlowKey = store.getters.getConfigItem('ocrFlowKey') || defaultKey;
  try {
    const ocrGrayList = JSON.parse(store.getters.getConfigItem('ocrGrayList') || '[]');
    const userid = sessionStorage.getItem('userid');
    const useNewKey = Array.isArray(ocrGrayList)
      && (ocrGrayList.length === 0 || ocrGrayList.includes(userid));
    if (useNewKey) {
      ocrFlowKey = store.getters.getConfigItem('ocrFlowNewKey') || ocrFlowKey;
    }
  } catch (grayError) {
    console.error('[agentApi] OCR灰度逻辑解析失败:', grayError);
    // 上报灰度解析异常到aegis
    try {
      const { aegis } = store.state.user;
      if (aegis) {
        aegis.infoAll({
          msg: JSON.stringify({
            type: 'ocr_gray_parse_error',
            userid: sessionStorage.getItem('userid'),
            error: grayError && grayError.message,
            timestamp: Date.now()
          }),
          ext1: 'ocr-gray-parse-error'
        });
      }
    } catch (reportError) {
      console.error('[agentApi] Aegis上报失败:', reportError);
    }
  }
  return ocrFlowKey;
}

/**
 * OCR 图片识别
 * @param {string} imageUrl - 图片URL
 * @param {string} extraPrompt - 额外提示词
 * @param {Object} axiosConfig - 额外的 axios 配置
 * @param {string} ProcessDefinitionKey - 应用/流程标识
 * @param {Object} options - 可选项：{ skipGray: 是否跳过灰度直接使用传入的 ProcessDefinitionKey }
 * @returns {Promise}
 */
export function ocrImage(imageUrl, extraPrompt, axiosConfig = {}, ProcessDefinitionKey = 'ocr_photo_new', options = {}) {
  // 新版OCR 使用独立应用（如 ocr_photo_new_copy_copy），不参与灰度覆盖
  const finalProcessDefinitionKey = options && options.skipGray
    ? ProcessDefinitionKey
    : getOcrFlowKey(ProcessDefinitionKey);
  const params = {
    Action: 'Agent',
    Data: {
      CustomVariables: {
        Query: imageUrl,
        extraPrompt: extraPrompt || undefined
      },
      ProcessDefinitionKey: finalProcessDefinitionKey,
      Source: 'dcops',
      TicketDescription: 'OCR图片识别',
      TicketLevel: 3,
      TicketTitle: 'OCR图片识别',
      UserInfo: {
        Concern: sessionStorage.getItem('userid'),
        Creator: sessionStorage.getItem('userid'),
        Deal: sessionStorage.getItem('userid')
      }
    },
    Method: 'CallAgent'
  };
  
  return callAgent(params, axiosConfig);
}
